import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { LOCALE_ID } from '@angular/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { AppConsole } from './app/api/helper/app-console';

AppConsole.init();

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, {
        providers: [{ provide: LOCALE_ID, useValue: 'de-DE' }]
    })
    .catch(err => console.log(err));
